import { typedAction } from "../actionTypes";
import { SET_MENU_OPTION, DIALOG_OPEN, ROUTER_PAYLOAD_UPDATER, SET_MENU_DRAWER, SET_IS_MOBILE, SET_SIGNUP_POPUP } from "./navigationConstant";
import { MenuOptionType } from "./navigationModels";

export function setMenuOption(option : MenuOptionType) {
  return typedAction(SET_MENU_OPTION, option);
}
export function dialogOpen(payload: boolean) {
  return typedAction(DIALOG_OPEN, payload);
}

export function routerParemUpdater(payload: any) {
  return typedAction(ROUTER_PAYLOAD_UPDATER, payload);
}

export function setMenuDrawer(show: boolean) {
  return typedAction(SET_MENU_DRAWER, show);
}

export function setIsMobile(show: boolean) {
  return typedAction(SET_IS_MOBILE, show);
}

export function setSignupPopup(show: boolean) {
  return typedAction(SET_SIGNUP_POPUP, show);
}

export type navigationActions = ReturnType<
|typeof setMenuOption
| typeof routerParemUpdater
| typeof dialogOpen
| typeof setMenuDrawer
| typeof setIsMobile
| typeof setSignupPopup
>;
